import { useEffect, useRef } from "react";

interface UseIdleTimeoutProps {
  callback: () => Promise<void> | void;
  idleTimeout?: number; // in milliseconds; defaults to 5 minutes
}

export default function useIdleTimeout({ callback, idleTimeout = 5 * 60 * 1000 }: UseIdleTimeoutProps): { resetIdleTimer: () => void } {
  const timer = useRef<NodeJS.Timeout | null>(null);

  const resetIdleTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      callback();
    }, idleTimeout);
  };

  useEffect(() => {
    resetIdleTimer();
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);

  return { resetIdleTimer };
}
